<template>
  <div class="recruitment-info">
    <div class="recruitment-title">招聘信息</div>
    <div class="recruitment-panel">
      <div class="recruitment-list">
        <div :class="['panel-item', { 'item-active': item.id === recruitDetails.id }]"
             v-for="item in recruitList" :key="item.id" @click="handleActive(item)">
          <div class="item-name">{{ item.position }}</div>
          <div class="item-experience">
            <span class="experience-one">{{ newExperienceList[item.experience] }}工作经验</span>
            <span class="experience-two">{{ newQualificationList[item.qualification] }}</span>
          </div>
          <div class="item-label" v-if="item.jobLabel">
            <span v-for="it in item.jobLabel.split(',')" :key="it" class="item-label-single">[{{ it }}]</span>
          </div>
          <div class="item-benefits" v-if="item.jobBenefits">
            <div v-for="benefits in item.jobBenefits.split(',')" :key="benefits" class="item-benefits-single">
              {{ benefits }}
            </div>
          </div>
          <div class="item-address">
            <div class="item-address-info">
              <div class="address-info-icon"><img src="@/assets/images/address.png" alt=""/></div>
              <div class="address-info-txt">{{ item.workCity }}</div>
            </div>
            <div class="item-address-time">更新于{{ formatDayYYYYMMDD(item.createTime) }}</div>
          </div>
        </div>
      </div>
      <div class="recruitment-details">
        <div class="recruitment-duty">
          <div class="recruitment-duty-name">岗位职责</div>
          <div class="recruitment-duty-info">
            <p v-for="(item,index) in jobDutyList" :key="index">{{item.endsWith("；") ? item : item+"；"}}</p>
          </div>
        </div>
        <div class="recruitment-job">
          <div class="recruitment-job-name">职位要求</div>
          <div class="recruitment-job-info">
            <p v-for="(item,index) in jobRequirementList" :key="index">{{item.endsWith("；") ? item : item+"；"}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {newExperienceList, newQualificationList} from "@/utils/title";
import {formatDayYYYYMMDD} from "@/utils/day";
import {getRecruitList} from "@/api/apiRecruitment";
import {computed, ref} from "vue";
const recruitList = ref([])
const recruitDetails = ref({})
const queryRecruitList = async () => {
  const {code, data} = await getRecruitList({pageNum: 1, pageSize: 100})
  if (code === 200) {
    recruitList.value = data.records
    recruitDetails.value = recruitList.value.length > 0 ? recruitList.value[0] : {}
  }
}
const handleActive=(data)=>{
  recruitDetails.value=data
}
const jobDutyList = computed(function () {
  if (recruitDetails.value.jobDuty) {
    const list=recruitDetails.value.jobDuty.replaceAll(/\n/g, "").replaceAll(';',"；");
    return list.split("；").filter(Boolean);
  }
  return []
})
const jobRequirementList = computed(function () {
  if (recruitDetails.value.jobRequirement) {
    const list=recruitDetails.value.jobRequirement.replaceAll(';',"；").replaceAll(/\n/g, "");
    return list.split("；").filter(Boolean);
  }
  return []
})
queryRecruitList()

</script>

<style lang="scss" scoped>
.recruitment-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  position: relative;
  text-align: center;
}

.recruitment-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.recruitment-info {
  margin: 70px 0;
}
.recruitment-panel {
  height: 651px;
  margin-top: 50px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  background-image: url("~@/assets/images/recruitment.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.recruitment-list {
  overflow-y: auto;
  padding-right: 30px;
  /* 自定义滚动条 */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #E3E3E3 transparent; /* Firefox */
}
/* Webkit浏览器滚动条样式 */
.recruitment-list::-webkit-scrollbar {
  width: 5px; /* 滚动条宽度 */
}

.recruitment-list::-webkit-scrollbar-track {
  background: transparent; /* 轨道背景 */
}

.recruitment-list::-webkit-scrollbar-thumb {
  background: #E3E3E3; /* 滑块颜色 */
  border-radius: 5px; /* 圆角 */
  min-height: 136px; /* 最小高度（实际高度由内容决定） */
}
.panel-item {
  padding: 15px;
  box-sizing: border-box;
  width: 395px;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid #DBDBDB;
  margin-top: 20px;
  &:first-child{
    margin-top: 0;
  }
  .item-name {
    font-weight: bold;
    font-size: 16px;
    color: #242424;
  }

  .item-experience {
    margin-top: 15px;
    font-weight: bold;
    font-size: 14px;
    color: #797979;

    .experience-two {
      margin-left: 19px;
    }
  }

  .item-label {
    margin-top: 10px;
    font-size: 14px;
    color: #797979;

    .item-label-single {
      margin-right: 15px;
    }
  }

  .item-benefits {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    .item-benefits-single {
      font-size: 12px;
      color: #0048A9;
      background-color: rgba(0, 72, 169, 0.1);
      border-radius: 2px;
      padding: 2px 5px;
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }

  .item-address {
    display: flex;
    justify-content: space-between;
    margin-top: 7px;
    .item-address-info{
      display: flex;
    }
    .address-info-icon {
      width: 13px;
      height: 14px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

    }

    .address-info-txt {
      font-size: 14px;
      color: #797979;
      margin-left: 5px;
    }

    .item-address-time {
      font-size: 12px;
      color: #797979;
    }
  }
}

.item-active {
  border: 1px solid #0048A9;
}
.recruitment-details{
  margin-left: 40px;
  flex: 1;
}
.recruitment-duty-name,.recruitment-job-name{
  font-weight: bold;
  font-size: 20px;
  color: #242424;
}
.recruitment-duty-info{
  margin-bottom: 40px;
}
.recruitment-duty-info,.recruitment-job-info{
  margin-top: 22px;
  height: 210px;
  overflow-y: auto;
  font-size: 14px;
  color: #797979;
  line-height: 25px;
  padding-right: 20px;
  box-sizing: border-box;
  /* 自定义滚动条 */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #E3E3E3 transparent; /* Firefox */
}
/* Webkit浏览器滚动条样式 */
.recruitment-duty-info::-webkit-scrollbar {
  width: 5px; /* 滚动条宽度 */
}

.recruitment-duty-info::-webkit-scrollbar-track {
  background: transparent; /* 轨道背景 */
}

.recruitment-duty-info::-webkit-scrollbar-thumb {
  background: #E3E3E3; /* 滑块颜色 */
  border-radius: 5px; /* 圆角 */
  min-height: 136px; /* 最小高度（实际高度由内容决定） */
}
.recruitment-job-info::-webkit-scrollbar {
  width: 5px; /* 滚动条宽度 */
}
.recruitment-job-info::-webkit-scrollbar-track {
  background: transparent; /* 轨道背景 */
}

.recruitment-job-info::-webkit-scrollbar-thumb {
  background: #E3E3E3; /* 滑块颜色 */
  border-radius: 5px; /* 圆角 */
  min-height: 136px; /* 最小高度（实际高度由内容决定） */
}
</style>
